export default __webpack_public_path__ + "static/media/content-deco-1.809d9093.webp";